"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_1 = __importDefault(require("analytics"));
const segment_1 = __importDefault(require("@analytics/segment"));
const base_analytics_provider_1 = require("./base-analytics-provider");
const mixpanel_utils_1 = __importDefault(require("./mixpanel-utils"));
const INTERCOM = 'Intercom';
class SegmentProvider extends base_analytics_provider_1.BaseAnalyticsProvider {
    constructor(initData) {
        var _a;
        super();
        this.eventsToIntercom = ['Download SCORM 1.2 course', 'Upgrade now'];
        const { segmentWriteKey, mixpanel } = initData;
        this.mixpanel = new mixpanel_utils_1.default(mixpanel);
        try {
            (_a = this.mixpanel) === null || _a === void 0 ? void 0 : _a.on();
        }
        catch (error) {
            console.error('Error initializing Mixpanel:', error);
        }
        this.analytics = (0, analytics_1.default)({
            app: 'Easygenerator',
            plugins: [(0, segment_1.default)({ writeKey: segmentWriteKey })]
        });
        this.analytics.on('ready', () => {
            var _a;
            this.trackPage();
            (_a = this.mixpanel) === null || _a === void 0 ? void 0 : _a.addSegmentMiddleware();
        });
        this.isInitialized = true;
    }
    identifyUser(identity) {
        const { id, ...rest } = identity;
        this.timestamp = Date.now();
        this.integrations = {
            Amplitude: {
                session_id: this.timestamp
            }
        };
        this.analytics.reset();
        this.analytics.identify(id, rest);
    }
    updateUserIdentity(id, userProps) {
        this.analytics.identify(id, { ...userProps });
    }
    track(eventName, properties) {
        try {
            this.analytics.track(eventName, properties, {
                integrations: this.getTrackEventIntegrations(eventName)
            });
        }
        catch (err) {
            const { log } = console;
            log(err);
        }
    }
    trackPage() {
        this.analytics.page({}, { integrations: this.integrations });
    }
    performLogout() {
        var _a;
        this.analytics.reset();
        if (window.Intercom) {
            window.Intercom('shutdown');
        }
        (_a = this.mixpanel) === null || _a === void 0 ? void 0 : _a.off();
    }
    getTrackEventIntegrations(eventName) {
        const enableIntercom = eventName && this.eventsToIntercom.indexOf(eventName) !== -1;
        return { [INTERCOM]: enableIntercom };
    }
}
exports.default = SegmentProvider;
